module.exports = __webpack_public_path__ + "static/media/logo4.343384b2.png";